"use client";

import { JSX, Suspense, useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

import { PostHogProvider } from "posthog-js/react";
import posthog from "posthog-js";

function getCookie(name: string): string | undefined {
  return document.cookie
    .split("; ")
    .find((c) => c.startsWith(`${name}=`))
    ?.split("=")
    .slice(1)
    .join("=");
}

if (globalThis.window !== undefined && process.env.NEXT_PUBLIC_POSTHOG_KEY) {
  const marketingId = getCookie("marketing_id");
  const flagCookie = getCookie("demo_btn_text");

  let flagPayload: Record<string, string> | undefined;
  if (flagCookie) {
    try {
      flagPayload = JSON.parse(decodeURIComponent(flagCookie));
    } catch {
      // malformed cookie — ignore
    }
  }

  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
    capture_pageview: false,
    enable_recording_console_log: true,
    bootstrap: {
      distinctID: marketingId,
      ...(flagPayload && {
        featureFlags: { "marketing-demo-btn-text": true },
        featureFlagPayloads: { "marketing-demo-btn-text": flagPayload },
      }),
    },
  });
}

function PostHogPageviewComponent(): JSX.Element {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (pathname) {
      let url = globalThis.origin + pathname;
      if (searchParams?.toString()) {
        url = url + `?${searchParams.toString()}`;
      }
      posthog.capture("$pageview", {
        $current_url: url,
      });
    }
  }, [pathname, searchParams]);

  return <></>;
}

export function PostHogPageview(): JSX.Element {
  return (
    <Suspense fallback={null}>
      <PostHogPageviewComponent />
    </Suspense>
  );
}

export function PHProvider({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
